module.exports = __webpack_public_path__ + "media/images/flags/mw-b4d805efda655aef8b6e88cb546f2d80.svg";